function filteredServicesComponents(servicesStart, jobTypeFilter, executor) {
  let response = [];
   
  servicesStart.map(function (firstObject) {
    let addQuestions = false
    //if (executor) { response.push(firstObject) }
    if (firstObject.jobType && jobTypeFilter.includes(firstObject.jobType)) {
      response.push(firstObject);
    } else if (firstObject.data && firstObject.data[0] && firstObject.data[0][0] && firstObject.data[0][0].answers) {
      firstObject.data.forEach(function (firstAndHalfdObject) {

        firstAndHalfdObject.forEach(function (secondObject) {

          if (secondObject.jobType && jobTypeFilter.includes(secondObject.jobType)) {
            let index = response.findIndex(obj => obj.id === firstObject.id)
            if (index == -1) {
              response.push(firstObject)
              let index2 = response.findIndex(obj => obj.id === firstObject.id)
              response[index2].data = [[]]
            }
            let index2 = response.findIndex(obj => obj.id === firstObject.id)
          } else if (secondObject.answers[0]) {
            secondObject.answers.map(thirdObject => {
              /*lo nuevo*/
              if (thirdObject.subQuestionData && executor) {
                thirdObject.subQuestionData.forEach(fourthObject => {
                  if (fourthObject[0].name == "equipmentType") {
                    fourthObject[0].answers.forEach(fourthObject => {
                      if (fourthObject.jobType && jobTypeFilter.includes(fourthObject.jobType)) {
                        let index = response.findIndex(obj => obj.id === firstObject.id)
                        if (index == -1) {
                          response.push(firstObject)
                          let index2 = response.findIndex(obj => obj.id === firstObject.id)
                          response[index2].data = [[]]
                          index = index2
                        }
                        let secondIndex = response[index].data[0].findIndex(obj => obj.name === secondObject.name)
                        if (secondIndex == -1) {
                          response[index].data[0].push(secondObject)
                          let secondIndex2 = response[index].data[0].findIndex(obj => obj.name === secondObject.name)
                          response[index].data[0][secondIndex2].answers = []
                          response[index].data[0][secondIndex2].answers.push(thirdObject)
                          secondIndex = secondIndex2
                          response[index].data[0][secondIndex].answers[0]["subQuestionData"][2].answers = []
                        } else {
                          response[index].data[0][secondIndex].answers[0]["subQuestionData"][2].answers = []
                        }

                        let fourthLevel = response[index].data[0][secondIndex].answers[0]["subQuestionData"][2].answers

                        fourthLevel.push(fourthObject)


                      }

                    })
                  }
                })


              }

              /*lo nuevo termina*/
              /*otro mas nuevo*/
              if (thirdObject.data && executor) {

                thirdObject.data.forEach(fourthObject =>{
                  if(fourthObject.answers){
                    fourthObject.answers.forEach(fifthObject =>{
                      if(fifthObject.jobType && jobTypeFilter.includes(fifthObject.jobType)){
                        let index = response.findIndex(obj => obj.id === firstObject.id)
                        if (index == -1) {
                          response.push(firstObject)
                          let index2 = response.findIndex(obj => obj.id === firstObject.id)
                          response[index2].data = [[]]
                          index = index2
                        }
                        let secondIndex = response[index].data[0].findIndex(obj => obj.name === secondObject.name)
                        
                        if (secondIndex == -1) {
                          response[index].data[0].push(secondObject)
                          let secondIndex2 = response[index].data[0].findIndex(obj => obj.name === secondObject.name)
                          response[index].data[0][secondIndex2].answers = []
                          response[index].data[0][secondIndex2].answers.push(thirdObject)
                          secondIndex = secondIndex2  
                          let thirdIndex = response[index].data[0][secondIndex].answers.findIndex(obj => obj.id === thirdObject.id)
                          response[index].data[0][secondIndex].answers[thirdIndex].data[0].answers= []
                        } 
                         let thirdIndex = response[index].data[0][secondIndex].answers.findIndex(obj => obj.id === thirdObject.id)
                          if(thirdIndex == -1){
                            response[index].data[0][secondIndex].answers.push(thirdObject)
                            thirdIndex = response[index].data[0][secondIndex].answers.findIndex(obj => obj.id === thirdObject.id)
                            
                            response[index].data[0][secondIndex].answers[thirdIndex].data[0].answers= []
                          }
                          let fourthLevel = response[index].data[0][secondIndex].answers[thirdIndex].data[0].answers
                          fourthLevel.push(fifthObject)




                          

                      }
                    })
                  }

                })

              }
              /*lo mas nuevo termina*/

              else if (jobTypeFilter.includes(thirdObject.jobType)) {
                addQuestions = true
                let index = response.findIndex(obj => obj.id === firstObject.id)
                if (index == -1) {
                  response.push(firstObject)
                  let index2 = response.findIndex(obj => obj.id === firstObject.id)
                  response[index2].data = [[]]
                  index = index2
                }
                let secondIndex = response[index].data[0].findIndex(obj => obj.name === secondObject.name)
                if (secondIndex == -1) {
                  response[index].data[0].push(secondObject)
                  let secondIndex2 = response[index].data[0].findIndex(obj => obj.name === secondObject.name)
                  response[index].data[0][secondIndex2].answers = []
                  response[index].data[0][secondIndex2].answers.push(thirdObject)
                } else {
                  response[index].data[0][secondIndex].answers.push(thirdObject)
                }
              } else if (!thirdObject.jobType && !thirdObject.hiddenQuestionData && addQuestions == true) {
                let index = response.findIndex(obj => obj.id === firstObject.id)
                if (index == -1) {
                  response.push(firstObject)
                  let index2 = response.findIndex(obj => obj.id === firstObject.id)
                  response[index2].data = [[]]
                  index = index2
                }
                let secondIndex = response[index].data[0].findIndex(obj => obj.name === secondObject.name)
                if (secondIndex == -1) {
                  response[index].data[0].push(secondObject)
                  let secondIndex2 = response[index].data[0].findIndex(obj => obj.name === secondObject.name)
                  response[index].data[0][secondIndex2].answers = []
                  response[index].data[0][secondIndex2].answers.push(thirdObject)
                } else {
                  response[index].data[0][secondIndex].answers.push(thirdObject)
                }
              } else if (thirdObject.hiddenQuestionData) {
                thirdObject.hiddenQuestionData.map(fourthObject => {
                  if (fourthObject.answers[0]) {
                    fourthObject.answers.map(fifthObject => {
                      if (fifthObject.jobType && jobTypeFilter.includes(fifthObject.jobType)) {

                        let index = response.findIndex(obj => obj.id === firstObject.id)
                        if (index == -1) {
                          response.push(firstObject)
                          let index2 = response.findIndex(obj => obj.id === firstObject.id)
                          response[index2].data = [[]]
                          index = index2
                        }
                        let secondIndex = response[index].data[0].findIndex(obj => obj.name === secondObject.name)
                        if (secondIndex == -1) {
                          response[index].data[0].push(secondObject)
                          let secondIndex2 = response[index].data[0].findIndex(obj => obj.name === secondObject.name)
                          response[index].data[0][secondIndex2].answers = []
                          secondIndex = secondIndex2
                        }
                        let thirdIndex = response[index].data[0][secondIndex].answers.findIndex(obj => obj.id === thirdObject.id)
                        if (thirdIndex == -1) {
                          response[index].data[0][secondIndex].answers.push(thirdObject)
                          let thirdIndex2 = response[index].data[0][secondIndex].answers.findIndex(obj => obj.id === thirdObject.id)
                          response[index].data[0][secondIndex].answers[thirdIndex2].hiddenQuestionData = []
                          response[index].data[0][secondIndex].answers[thirdIndex2].hiddenQuestionData.push(fourthObject)
                          let fourthIndex = response[index].data[0][secondIndex].answers[thirdIndex2].hiddenQuestionData.findIndex(obj => obj.name === fourthObject.name)
                          response[index].data[0][secondIndex].answers[thirdIndex2].hiddenQuestionData[fourthIndex].answers = []
                          response[index].data[0][secondIndex].answers[thirdIndex2].hiddenQuestionData[fourthIndex].answers.push(fifthObject)
                          thirdIndex = thirdIndex2
                        } else {
                          let fourthIndex = response[index].data[0][secondIndex].answers[thirdIndex].hiddenQuestionData.findIndex(obj => obj.name === fourthObject.name)
                          if (fourthIndex == -1) {
                            response[index].data[0][secondIndex].answers[thirdIndex].hiddenQuestionData.push(fourthObject)
                            let fourthIndex2 = response[index].data[0][secondIndex].answers[thirdIndex].hiddenQuestionData.findIndex(obj => obj.name === fourthObject.name)
                            response[index].data[0][secondIndex].answers[thirdIndex].hiddenQuestionData[fourthIndex2].answers = []
                            response[index].data[0][secondIndex].answers[thirdIndex].hiddenQuestionData[fourthIndex2].answers.push(fifthObject)
                          } else {
                            response[index].data[0][secondIndex].answers[thirdIndex].hiddenQuestionData[fourthIndex].answers.push(fifthObject)
                          }
                        }

                      }
                    })

                  }

                })
              }
            });
          }
        });
      })
    }
  });

  return response;
}

export { filteredServicesComponents };
